import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import DOM from '../../../common/DOM';
import './popup.scss';

export default class Popup extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = { visible: false, className: '' };

        this.el = document.createElement('div');
        this.el.className = `popup-container ${props.className || ''} ${this.state.className}`;
        this.popupRoot = document.getElementById('child') || document.getElementsByClassName('widget-root')[0] || document.getElementsByTagName('body');

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.subscribed = false;
    }

    static getDerivedStateFromProps(newProps) {
        return {
            visible: newProps.visible,
            className: newProps.visible ? 'visible' : ''
        };
    }

    componentDidMount() {
        this.popupRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.disposed = true;
        
        this.popupRoot.removeChild(this.el);
    }

    attachEvents() {
        if(!this.subscribed) {
            this.subscribed = true;
            document.addEventListener('click', this.onDocumentClick, true);
            document.addEventListener('touchstart', this.onDocumentClick, true);
            window.addEventListener('resize', this.onWindowResize, true);
        }
    }

    detachEvents() {
        if(this.subscribed) {
            this.subscribed = false;
            document.removeEventListener('click', this.onDocumentClick, true);
            document.removeEventListener('touchstart', this.onDocumentClick, true);
            window.addEventListener('resize', this.onWindowResize, true);
        }
    }

    onDocumentClick(e) {
        if (this.disposed)
            return;
            
        if (this.el !== e.target && !this.el.contains(e.target) && this.props.relativeTo && this.props.relativeTo !== e.target && !this.props.relativeTo.contains(e.target)) {
            this.setState({
                visible: false,
                className: ''
            });
            if(this.props.onHide) {
                this.props.onHide(e);
            }
        }
    }

    onWindowResize() {
        if (this.disposed)
            return;

        this.setState({ popupStyle: this.popupStyle() });
    }

    popupStyle() {
        if (this.props.relativeTo) {
            if(this.props.fullScreen) 
                return 'left: 0px; top: 0px; right: 0px; bottom: 0px; width: 100%;';
            const pos = DOM.getElementPosition(this.props.relativeTo);
            const height = DOM.getElementHeight(this.props.relativeTo);
            return pos
                ? `left: ${pos.x}px; top: ${height + pos.y}px`
            // ? `left: 0px; top: ${height + (this.props.offsetY === undefined ? -10 : this.props.offsetY)}px`
                : 'left: 0px; top: 0px;';
        }
        return '';
    }

    render() {
        this.el.className = `popup-container ${this.props.className || ''} ${this.state.className}`;
        this.el.style.cssText = this.popupStyle();
        this.el.tabIndex = 0;
        if(this.state.visible) {
            this.attachEvents();
            setTimeout(() => this.el.focus(), 10);
        }
        else {
            this.detachEvents();
        }

        return ReactDOM.createPortal(this.props.children, this.el);
    }
}

Popup.defaultProps = {
    visible: false,
    fullScreen: false,
    className: ''
};

Popup.propTypes = {
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    relativeTo: PropTypes.instanceOf(Element),
    fullScreen: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.element
};
